import script from "./DiagnosticCardsEmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticCardsEmptyState.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosticCardsEmptyState.vue?vue&type=style&index=0&id=77e0d046&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e0d046"]])

export default __exports__